import React from "react";
import { FaChevronDown } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

export default function SideBarItemAdmin({ item, collapsed, isOpen, onToggle, signOut }) {
    const hasChildren = item.children && item.children.length > 0;
    const location = useLocation();

    // check if this item or any of its children matches the current route
    const isActive =
        item.to === location.pathname ||
        (hasChildren && item.children.some((sub) => sub.to === location.pathname));

    const content = (
        <div
            className={`flex items-center w-full text-left p-3 rounded-lg transition
            ${item.to ? "" : "cursor-pointer"} 
            ${isActive
                    ? "bg-[#FFE4E1] text-black font-semibold"
                    : "hover:bg-[#FFE4E1] hover:text-black"}
            `}
            onClick={
                item?.isLogout
                    ? signOut
                    : hasChildren
                        ? onToggle
                        : undefined
            }
        >
            <span
                className={`text-lg ${isActive ? "text-black" : "text-black"} group-hover:text-black`}
            >
                {item?.icon}
            </span>
            {!collapsed && (
                <span
                    className={`ml-3 flex-1 text-sm ${isActive ? "text-black" : "text-black group-hover:text-black"}`}
                >
                    {item.label}
                </span>
            )}
            {hasChildren && !collapsed && (
                <FaChevronDown
                    className={`ml-1 text-sm transition-transform duration-200 
                    ${isOpen ? "rotate-180" : "rotate-0"} 
                    ${isActive ? "text-black" : "text-gray-400 group-hover:text-black"}`}
                />
            )}
        </div>
    );

    return (
        <div>
            {item.to ? (
                <Link to={item?.to} state={item?.state}>
                    {content}
                </Link>
            ) : (
                content
            )}

            {/* Submenu */}
            {hasChildren && isOpen && !collapsed && (
                <div className="ml-6 mt-2 space-y-1 border-l border-slate-400 pl-3">
                    {item?.children?.map((sub, idx) => {
                        const subActive = sub.to === location.pathname;
                        return (
                            <Link
                                key={idx}
                                to={sub?.to || "#"}
                                state={sub?.state}
                                className={`flex items-center gap-3 px-3 py-2 text-sm rounded-lg transition-all duration-200
                                    ${subActive
                                        ? "bg-[#FFE4E1] text-black font-semibold"
                                        : "text-black hover:bg-[#FFE4E1] hover:text-black hover:pl-4"}
                                `}
                            >
                                <span>{sub?.icon}</span>
                                <span>{sub?.label}</span>
                            </Link>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
